module.exports = __webpack_public_path__ + "es_ES-header-d6c3e7.webp";